"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("./Header/Header"));

var _Actions = _interopRequireDefault(require("./Actions/Actions"));

var _Snackbar = _interopRequireDefault(require("./Snackbar.style"));

var Snackbar = function Snackbar(_ref) {
  var className = _ref.className,
      label = _ref.label,
      icon = _ref.icon,
      onIconClick = _ref.onIconClick,
      onCancel = _ref.onCancel,
      buttons = _ref.buttons,
      id = _ref.id,
      remove = _ref.remove,
      style = _ref.style,
      status = _ref.status;
  var footerButtons = Array.from(buttons);
  return _react.default.createElement("div", {
    style: {
      display: 'block'
    }
  }, _react.default.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, _react.default.createElement(_Snackbar.default, {
    style: style,
    className: className,
    remove: remove
  }, _react.default.createElement(_Header.default, {
    label: label,
    id: id,
    status: status
  }), _react.default.createElement(_Actions.default, {
    icon: icon,
    onIconClick: onIconClick || onCancel,
    buttons: footerButtons,
    id: id
  }))));
};

Snackbar.defaultProps = {
  remove: false,
  className: null,
  icon: 'close',
  buttons: [],
  style: {}
};
Snackbar.propTypes = {
  id: _propTypes.default.string.isRequired,
  remove: _propTypes.default.bool,
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func.isRequired]).isRequired,
  icon: _propTypes.default.string,
  onCancel: _propTypes.default.func.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })),
  style: _propTypes.default.object
};
var _default = Snackbar;
exports.default = _default;